function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.79 20.76L21.07 20.04C21.44 19.48 21.66 18.8 21.66 18.08C21.66 16.1 20.06 14.5 18.08 14.5C16.1 14.5 14.5 16.1 14.5 18.08C14.5 20.06 16.1 21.66 18.08 21.66C18.81 21.66 19.48 21.44 20.04 21.07L20.76 21.79C20.9 21.93 21.09 22 21.27 22C21.46 22 21.64 21.93 21.78 21.79C22.07 21.5 22.07 21.04 21.79 20.76Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.03001 14.6299C2.03001 14.6599 2.01001 14.6999 2.01001 14.7299C2.93001 16.5699 4.43001 18.0799 6.27001 18.9899C6.30001 18.9899 6.34001 18.9699 6.37001 18.9699C6.03001 17.8099 5.77001 16.6199 5.58001 15.4299C4.38001 15.2299 3.19001 14.9699 2.03001 14.6299Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.07 6.43043C18.13 4.46043 16.54 2.87043 14.58 1.94043C14.94 3.13043 15.24 4.35043 15.44 5.57043C16.66 5.77043 17.88 6.06043 19.07 6.43043Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.92999 6.42953C3.12999 6.06953 4.34999 5.76953 5.56999 5.56953C5.76999 4.37953 6.01999 3.19953 6.35999 2.03953C6.32999 2.03953 6.28999 2.01953 6.25999 2.01953C4.37999 2.94953 2.84999 4.51953 1.92999 6.42953Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.82 5.36C13.58 4.06 13.28 2.76 12.85 1.5C12.83 1.43 12.83 1.37 12.82 1.29C12.08 1.11 11.3 1 10.5 1C9.68999 1 8.91999 1.11 8.16999 1.3C8.15999 1.37 8.16999 1.43 8.14999 1.51C7.72999 2.77 7.41999 4.06 7.17999 5.36C9.38999 5.12 11.61 5.12 13.82 5.36Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.36 7.17969C4.05 7.41969 2.77 7.72969 1.5 8.14969C1.43 8.16969 1.37 8.16969 1.3 8.17969C1.11 8.91969 1 9.69969 1 10.4997C1 11.3097 1.11 12.0797 1.3 12.8297C1.37 12.8397 1.43 12.8297 1.51 12.8497C2.77 13.2697 4.06 13.5797 5.37 13.8197C5.12 11.6097 5.12 9.38969 5.36 7.17969Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7 8.17969C19.63 8.17969 19.57 8.16969 19.49 8.14969C18.23 7.72969 16.93 7.41969 15.63 7.17969C15.88 9.38969 15.88 11.6097 15.63 13.8097C16.93 13.5697 18.23 13.2697 19.49 12.8397C19.56 12.8197 19.62 12.8297 19.7 12.8197C19.88 12.0697 20 11.2997 20 10.4897C20 9.69969 19.89 8.92969 19.7 8.17969Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M7.17999 15.6399C7.41999 16.9499 7.71999 18.2399 8.14999 19.4999C8.16999 19.5699 8.15999 19.6299 8.16999 19.7099C8.91999 19.8899 9.68999 19.9999 10.5 19.9999C11.3 19.9999 12.08 19.8899 12.82 19.6999C12.83 19.6299 12.83 19.5699 12.85 19.4899C13.27 18.2299 13.58 16.9399 13.82 15.6299C12.72 15.7499 11.61 15.8399 10.5 15.8399C9.38999 15.8399 8.27999 15.7599 7.17999 15.6399Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M6.94998 6.94961C6.64998 9.30961 6.64998 11.6896 6.94998 14.0596C9.30998 14.3596 11.69 14.3596 14.06 14.0596C14.36 11.6996 14.36 9.31961 14.06 6.94961C11.69 6.64961 9.30998 6.64961 6.94998 6.94961Z",
  fill: "white"
});

var SvgGlobalSearch = function SvgGlobalSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlobalSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/global-search.b29eaa1c.svg";
export { ForwardRef as ReactComponent };